// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.71ddf9019',
  revision: '71ddf9019',
  branch: 'develop',
  date: 'Thu, 27 Aug 2026 14:12:24 GMT'
};